import React, { useState } from "react";
import "./Register.css";
import { IoMdCloseCircleOutline } from "react-icons/io";

const Register = ({ handleModalOpen }) => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!userName || !email || !password) {
      alert("Please fill in Username, Email, and Password.");
      return;
    }

    try {
      const response = await fetch(
        "https://web-api.chauwk.com/api/enterprise/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password,
            userName,
            role: "rc", // or remove if not needed
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        alert("Registration successful!");
        window.location.href = "https://enterprise.chauwk.com/dashboard";
      } else {
        alert(data.msg || "Registration failed.");
      }
    } catch (error) {
      console.error("Registration error:", error);
      alert("Registration failed. Please try again.");
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <div className="close-icon" onClick={() => handleModalOpen(null)}>
          <IoMdCloseCircleOutline size={30} />
        </div>

        <h2>Enterprise Register</h2>
        <form onSubmit={handleRegister}>
          <input
            type="text"
            placeholder="Username"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {/* Terms & Conditions link */}
          <p
            style={{
              fontSize: "13px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            By registering, you agree to our{" "}
            <a
              href="https://enterprise.chauwk.com/agreement"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#002cc7", textDecoration: "underline" }}
            >
              Terms & Conditions
            </a>
          </p>

          <button type="submit">Register</button>

          {/* Login button */}
          <button
            type="button"
            className="signin-btn"
            onClick={() =>
              (window.location.href = "https://www.enterprise.chauwk.com/")
            }
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
